<template>
    <div class="success">
        <img src="../assets/submit.png" alt="">
        <p class="p1">预约提交成功</p>
        <p class="p2">我们的客服会尽快联系您，请耐心等待</p>
        <div class="btn">
        <button @click="order()">查看我的预约记录</button>
      </div>
    </div>
</template>

<script>
export default {
  methods: {
    order() {
      this.$router.push({
        path: "/order",
      });
    }
  }
};
</script>

<style scoped>
img {
  width: 78px;
  height: 78px;
  margin: 0 auto;
  margin-top: 57px;
}
.p1,
.p2 {
  text-align: center;
}
.p1 {
  font-size: 18px;
  margin-top: 12px;
}
.p2 {
  font-size: 16px;
  margin-top: 75px;
}
.btn {
  margin: 0 20px;
}
.btn button {
  height: 48px;
  line-height: 48px;
  font-size: 18px;
  margin-top: 80px;
  text-align: center;
  background: #e24709;
  color: #fff;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/success.vue